// MUI STYLES
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
  },
  contentContainer: {
    flex: 1,
    height: '100%',
    padding: '0 24px 24px 24px',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
    backgroundColor: theme.palette.background.default,
  },
}))

export default useStyles